export default __webpack_public_path__ + "static/media/movies.inline.7556e012.svg";